module.exports = __webpack_public_path__ + "static/media/trip-advisor-review.94ffe5da.svg";